import {createSelector} from 'redux-starter-kit';
import {ITransaction} from 'data/interfaces/transactions';

export const transactionSelector = ((product) => createSelector([`transactions`], (transactions: ITransaction[]) => {
  return transactions.find(transaction => transaction.product_id === product.id);
}));
